import { render, staticRenderFns } from "./Block.vue?vue&type=template&id=47460774&scoped=true"
import script from "./Block.vue?vue&type=script&lang=ts"
export * from "./Block.vue?vue&type=script&lang=ts"
import style0 from "./Block.vue?vue&type=style&index=0&id=47460774&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47460774",
  null
  
)

export default component.exports